module.exports = __webpack_public_path__ + "img/202MD.750.2118bff1.png";